module.exports = __webpack_public_path__ + "img/62.cd5f329f.png";